import React from 'react';
import styles from "./Page404.module.scss" ;

const Page404 = () => {

    return (

        <div className={styles.mainDiv404}>


            <span className={styles.text404}>404 | Notfound</span>
            
        </div>
    );
};

export default Page404;